// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__PfOcL","part":"default_part__qNObt","cursored":"default_cursored__6NKMr","active":"default_active__T91tO"};